// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import AttentionDisable from '../_raw/ui/icon_attention_disable.svg';
import withIconProps from '../withIconProps';

export default withIconProps(AttentionDisable);
